export const buildContactEmail = (): string => {
  const localParts = ["niv", "romano"];
  const domainParts = ["gmail", "com"];

  return `${localParts.join(".")}@${domainParts.join(".")}`;
};

export const buildMailtoUrl = (): string => {
  return `mailto:${buildContactEmail()}`;
};
